<template>
  <div class="discussion-cmenu">
    <v-menu bottom left v-model="menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small v-bind="attrs" v-on="on">
          <v-icon class="fal fa-ellipsis-stroke" size="20"></v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-if="item.canUpdate" @click="$emit('editComment', item)">
          <v-list-item-title>
            <v-icon class="fas fa-pen pr-2" size="15"></v-icon>
            {{ $gettext("Edit") }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="item.canDelete"
          @click="$emit('deleteComment', item.id)"
        >
          <v-list-item-title>
            <v-icon class="fas fa-trash-can pr-2" size="15"></v-icon>
            {{ $gettext("Delete") }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="!item.canUpdate"
          @click="$emit('reportComment', item.id)"
        >
          <v-list-item-title>
            <v-icon class="fal fa-circle-exclamation pr-2" size="15"></v-icon>
            {{ $gettext("Report") }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    closeMenu() {
      this.menu = false;
    },
  },
};
</script>